
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puzzle/view",
      function () {
        return require("private-next-pages/puzzle/view.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puzzle/view"])
      });
    }
  